import PropTypes from 'prop-types';
import {SunIcon, MinimalIcon, MoonIcon} from './icons';

export default function LandingPage({theme, onToggleTheme}) {
    const nextIcon = theme === 'dark' ? <SunIcon/> : theme === 'light' ? <MinimalIcon/> : <MoonIcon/>;
    return (
        <div className="landing" data-theme={theme}>
            <nav className="landing-nav">
                <div className="landing-nav-right">
                    <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
                        {nextIcon}
                    </button>
                    <a href="/?signin" className="landing-signin">Sign in</a>
                </div>
            </nav>
            <main className="landing-main">
                <div className="landing-cta">
                    <h1 className="landing-cta-h">Ready to <em>check</em><br/>things off?</h1>
                    <p className="landing-cta-sub">Open the app. Start a list. Nothing else required.</p>
                    <a href="/?signin" className="landing-btn_primary">Open Checklists →</a>
                </div>
            </main>
            <footer className="landing-footer">
                <div className="landing-footer-copy">© 2026</div>
            </footer>
        </div>
    );
}

LandingPage.propTypes = {
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
};
